import GameDataProvider from "app/game-data/GameDataProvider";
import GameOver from "app/game-over/GameOver";
import Game from "app/game/Game";
import GameProvider from "app/game/GameProvider";
import { useGameActionDispatch, useGameState } from "app/game/useGame";
import useNewGame from "app/game/useNewGame";
import { ScoreProvider } from "app/score/ScoreProvider";
import TopNav from "app/top-nav/TopNav";
import Credits from "app/ui/Credits";
import HowToPlay from "app/ui/HowToPlay";
import TitleScreen from "app/ui/TitleScreen";
import { useGlobalReset } from "app/utils/useResetableStorage";
import { useEffect, useState } from "react";
import { GameAction } from "./game/gameState";

function App() {
  const { isOnTitle, isOnGameOver, inputType } = useGameState();
  const gameDispatch = useGameActionDispatch();
  const [howToPlayOpen, setHowToPlayOpen] = useState(false);
  const [creditsOpen, setCreditsOpen] = useState(false);

  useNewGame();

  // Detect whether the user is using a touch device or a mouse by adding a
  // pointerdown listener to the window.
  useEffect(() => {
    function handlePointerDown(e: PointerEvent) {
      if (e.pointerType === "mouse") {
        if (inputType !== "mouse") {
          gameDispatch({
            type: GameAction.NEW_INPUT_TYPE_DETECTED,
            payload: { inputType: "mouse" },
          });
        }
      } else {
        if (inputType !== "touch") {
          gameDispatch({
            type: GameAction.NEW_INPUT_TYPE_DETECTED,
            payload: { inputType: "touch" },
          });
        }
      }
    }

    window.addEventListener("pointerdown", handlePointerDown);

    return () => {
      window.removeEventListener("pointerdown", handlePointerDown);
    };
  }, [gameDispatch, inputType]);

  if (howToPlayOpen) {
    return <HowToPlay onClose={() => setHowToPlayOpen(false)} />;
  }

  if (creditsOpen) {
    return <Credits onClose={() => setCreditsOpen(false)} />;
  }

  if (isOnTitle) {
    return <TitleScreen />;
  }

  if (isOnGameOver) {
    return <GameOver />;
  }

  return (
    <div className="flex h-full flex-col">
      <TopNav
        hideMenuButton={false}
        onHowToPlayClick={() => setHowToPlayOpen(true)}
        onCreditsClick={() => setCreditsOpen(true)}
      />
      <Game />
    </div>
  );
}

function WrappedApp() {
  useGlobalReset();

  return (
    <GameDataProvider>
      <ScoreProvider>
        <GameProvider>
          <App />
        </GameProvider>
      </ScoreProvider>
    </GameDataProvider>
  );
}

export default WrappedApp;
